import React from 'react';
import Card from 'components/Card';
import { OptionCardContainer } from '../OptionCard/style';
import { CustomizedRadio } from 'components/CustomizedRadio';

interface Attribute {
  icon: React.ReactElement;
  text: string;
}

type OptionCardModifyRoomTypeProps = {
  title: string;
  titleIcon: React.ReactElement;
  description: string;
  attributes: Attribute[];
  roomTypeId: string;
  roomTypeName: string;
  pricePerNight: number;
  bed: string;
  hasWindows: boolean;

  className?: string;
  selectedTitle?: boolean;
  priceLabel?: string;

  // Controlled selection (no persistence inside)
  isSelected: boolean;
  onSelect?: () => void;
};

const OptionCardModifyRoomType: React.FC<OptionCardModifyRoomTypeProps> = ({
  title,
  titleIcon,
  description,
  attributes,
  roomTypeId,
  roomTypeName,
  pricePerNight,
  bed,
  hasWindows,
  className,
  selectedTitle = false,
  priceLabel,
  isSelected,
  onSelect
}) => {
  return (
    <Card
      pointer={true}
      selected={isSelected}
      className={className}
    >
      <OptionCardContainer
        selected={isSelected}
        onClick={onSelect}
      >
        <div className="optionCardTitle">
          <div className={`title ${selectedTitle ? 'titleSelected' : ''}`}>
            {title}
          </div>

          <div className="description">
            {titleIcon}
            <span>{description}</span>
          </div>
        </div>

        <div className="optionCardAttributes">
          {attributes.map((attribute, index) => (
            <div key={index} className="roomAttribute">
              <div className="roomAttributeIcon">{attribute.icon}</div>
              {attribute.text}
            </div>
          ))}
        </div>

        <div className="optionCardPrice">
          <div className="radioAndPrice">
            <CustomizedRadio checked={isSelected} />

            <div className="priceDiff">
              {priceLabel ?? `${pricePerNight.toFixed(2)}$`}
            </div>
          </div>

          <div className="explanation">
            per night, not including tax / fees
          </div>
        </div>
      </OptionCardContainer>
    </Card>
  );
};

export default OptionCardModifyRoomType;